// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__3cTLT","active":"NavigationItem_active__BqM7u"};